import { SeenPatch } from '@weblite/ts-action/room'
import {
  DBFind,
  DBFindOne,
  DBInsert,
  DBRemoveMany,
  DBUpdateOne,
} from '@weblite/persist'

// TODO is mutex needed here?
const SEEN_COLLECTION = 'seenSync'

interface SeenPatchSync {
  roomId: string
  type: SeenPatch['type']
  seen: SeenPatch['seen']
  ignoreUpdateRoomSeen: SeenPatch['ignoreUpdateRoomSeen']
}

export async function set(
  roomId: string,
  seen: number,
  roomType: SeenPatch['type'],
  ignoreUpdateRoomSeen: boolean,
) {
  const { seen: oldSeen } = (await DBFindOne(SEEN_COLLECTION, roomId)) || {}
  if (oldSeen) {
    if (oldSeen < seen)
      await DBUpdateOne(SEEN_COLLECTION, roomId, {
        $set: {
          seen,
          ignoreUpdateRoomSeen,
        },
      })
  } else {
    await DBInsert(SEEN_COLLECTION, {
      seen,
      roomId,
      type: roomType,
      ignoreUpdateRoomSeen,
    })
  }
}

export async function getAll() {
  return (await DBFind(SEEN_COLLECTION)) as SeenPatchSync[]
}

/** Remove connected fields */
export async function del(roomIds: string[]): Promise<void> {
  await DBRemoveMany(SEEN_COLLECTION, roomIds)
}
